// src/assets/imageLoader.js

import f1 from './images/farmerImage/f1.png';
import f2 from './images/farmerImage/f2.png';
import f3 from './images/farmerImage/f3.png';
import f4 from './images/farmerImage/f4.png';
import f5 from './images/farmerImage/f5.png';
import f6 from './images/farmerImage/f6.png';
import f7 from './images/farmerImage/f7.png';
import f8 from './images/farmerImage/f8.png';
import default_image from './images/farmerImage/default_image.png';

const staticImages = {
  '/image/farmerImage/f1.png': f1,
  '/image/farmerImage/f2.png': f2,
  '/image/farmerImage/f3.png': f3,
  '/image/farmerImage/f4.png': f4,
  '/image/farmerImage/f5.png': f5,
  '/image/farmerImage/f6.png': f6,
  '/image/farmerImage/f7.png': f7,
  '/image/farmerImage/f8.png': f8,
  '/image/farmerImage/default_image.png': default_image,
};

const loadImage = (path) => {
  // Case 1: Path is null, undefined, or empty. Return default.
  if (!path) {
    return default_image;
  }

  // Case 2: Path is for a newly uploaded file stored on the backend.
  // Construct the full URL.
  if (path.startsWith('/uploads/') || path.startsWith('uploads/')) {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${backendUrl}${normalizedPath}`;
  }

  // Case 3: Path is for an old, statically imported image.
  if (staticImages[path]) {
    return staticImages[path];
  }
  
  // Case 4: Fallback to default if the path is unrecognized.
  return default_image;
};

export default loadImage;
